import { Button } from '@/components/ui';

/* The one Save for a tab. Sticky at the bottom of the panel when the form is
   the last thing on the tab, so a long form never scrolls its Save away — the
   original complaint about the dialog. Static when another section follows,
   because a bar floating over unrelated content reads as belonging to it. */
export function SaveFooter({
  dirty, saving, err, onSave, label = 'Save changes', sticky = true,
}: {
  dirty: boolean;
  saving: boolean;
  err: string | null;
  onSave: () => void;
  label?: string;
  sticky?: boolean;
}) {
  return (
    <div className={`admin-form__foot ${sticky ? '' : 'admin-form__foot--static'}`.trim()}>
      {err && <span className="admin-modal__err">{err}</span>}
      {!err && dirty && <span className="dash-muted admin-modal__hint">Unsaved changes</span>}
      <Button variant="primary" size="sm" onClick={onSave} disabled={saving || !dirty}>
        {saving ? 'Saving…' : label}
      </Button>
    </div>
  );
}
